var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
var {
  AppRegistry,
  View,
  Image,
  Platform,
  findNodeHandle
} = ReactNative;

var moment = require('moment');

var DatePicker = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      date: null,
      format: 'YYYY-MM-DD'
    }
  },

  getInitialState : function()
  {
    var inputValue = '';
    var dateValue = null;
    if (typeof this.props.value === 'string') {
      dateValue = moment(this.props.value, this.props.format);
    } else {
      dateValue = moment(this.props.value);
    }
    if (dateValue.isValid()) {
      inputValue = dateValue.format(this.props.format);
    }
    return {
      inputValue: inputValue
    };
  },

  componentDidMount : function()
  {
  },

  handleInput : function(e)
  {
    console.log(e.target.value)
    this.setState({
      inputValue: e.target.value
    });
  },

  handleBlur : function()
  {
    var value = moment(this.state.inputValue, this.props.format);
    console.log("handleBlur", value)
    this.props.onDateChange && this.props.onDateChange(value.isValid() ? value.toDate() : null, value.isValid() ? this.state.inputValue : null);
  },

  onPressDate : function()
  {
    // if( this._dateInput ) this._dateInput.focus();
  },

  render: function()
  {
    return <View style={this.props.style}>
      <input value={this.state.inputValue} onChange={this.handleInput} onBlur={this.handleBlur} style={{fontSize:20}} type="date" />
    </View>
  }
});

module.exports = DatePicker;
